import EvaluationService from 'services/data-handler-services/evaluation-service';
import Backbone from 'backbone';
import EF from 'ef/ef';

const SurveyService = function () {
  this.getRedirectUrlForCurrentPage = function (blockView) {
    const currentPage = EF.module.currentActivity.currentPage ? EF.module.currentActivity.currentPage.path() : '';
    const returnHash = blockView.model.get('return_hash') || `#${currentPage}`;
    return `${returnHash}?surveyTaken=true`;
  };

  this.triggerSurvey = function (blockView) {
    const redirectUrl = this.getRedirectUrlForCurrentPage(blockView);
    const data = {
      event_type: 'survey-initialized',
      redirectUrl: redirectUrl,
      slug: blockView.model.get('slug'),
    };
    window.postMessage(data, window.location.origin);
  };

  this.userHasCompletedSurvey = function (courseSlug) {
    return EvaluationService.userHasCompletedEvaluation(courseSlug);
  };

  this.getSurvey = function (blockView) {
    return EvaluationService.expandedResponseSet(blockView.model.get('slug'))
      .then(() => this.getSurveyResponseModel(blockView))
      .then(surveyResponseModel => {
        const foundryAllowAnswerChange = surveyResponseModel.get('evaluation').allow_changing_answers;
        if (foundryAllowAnswerChange !== undefined) {
          surveyResponseModel.set('allow_answer_change', foundryAllowAnswerChange);
        }

        blockView.model.set('responseSet', surveyResponseModel);
        // sections is not set on the survey model for some reason
        // this has to be handled here or in the template
        blockView.model.set('translate', false);
        blockView.model.get('survey').set('sections', surveyResponseModel.get('sections'));
        blockView.render();
      });
  };

  this.saveSurveyResponse = async function (blockView, dataset, opts) {
    const surveyResponseModel = await this.getSurveyResponseModel(blockView);
    let options;
    if (opts && opts.multipleQuestion) {
      options = surveyResponseModel.save(dataset);
    } else {
      options = surveyResponseModel.save([{ question_id: dataset.questionId, answer_id: dataset.answerId }]);
    }
    return Backbone.Model.prototype.save.call(surveyResponseModel, options.attrs, options);
  };

  this.refreshResponseSet = function (slug) {
    return EvaluationService.refreshResponseSet(slug);
  };

  this.getSurveyResponseModel = function (blockView) {
    return EvaluationService.findEvaluationBySlug(blockView.model.get('slug'));
  };
};

export default new SurveyService();
